import { ApiPath } from "enums";
import { Get } from "utils";

export const getFleets = async () => {
  const res = await Get(`${ApiPath.User}/fleet`);
  return res.data;
};
